import { render } from "./VueGeofenceInformation.vue?vue&type=template&id=563d1527"
import script from "./VueGeofenceInformation.vue?vue&type=script&lang=js"
export * from "./VueGeofenceInformation.vue?vue&type=script&lang=js"

import "./VueGeofenceInformation.vue?vue&type=style&index=0&id=563d1527&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__